import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'
import {FeInputFieldStatus} from '@modifi/enums'
import {
  selectIntermediaryShareholderByExternalId,
  selectCanUpdateCompany,
  selectIntermediaryShareholdingCompanyName,
} from '../../../../data/intermediary-shareholders'
import ExistingIntermediaryShareHolders, {
  ExistingIntermediaryShareHolderProps,
} from './ExistingIntermediaryShareHolders'
import {
  aReset,
  aSavePage,
  selectInitialFormDataForEditing,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {SECTION_INTERMEDIARY_SHAREHOLDERS} from '../../../../constants/sections'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>,
  ownProps: Record<string, any>
): Pick<
  ExistingIntermediaryShareHolderProps,
  | 'externalIntermediaryShareholderId'
  | 'isLoading'
  | 'isValidShareholderId'
  | 'updatePending'
  | 'formData'
  | 'hasError'
  | 'errorMessage'
  | 'pageIsVerified'
  | 'canUpdateCompany'
  | 'shareholdingCompanyName'
> => {
  const externalIntermediaryShareholderId = ownProps?.match?.params?.externalId

  const isLoading = selectInitializePagePending(state, externalIntermediaryShareholderId)
  return {
    externalIntermediaryShareholderId,
    isLoading,
    isValidShareholderId:
      isLoading ||
      selectIntermediaryShareholderByExternalId(state, externalIntermediaryShareholderId)
        ?.externalId === externalIntermediaryShareholderId,
    updatePending: selectSavePending(state),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    formData: selectInitialFormDataForEditing(state, externalIntermediaryShareholderId!),
    hasError: selectSaveHasError(state),
    errorMessage: selectSaveErrorMessage(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_INTERMEDIARY_SHAREHOLDERS) ===
      FeInputFieldStatus.VERIFIED,
    canUpdateCompany: !!selectCanUpdateCompany(state, externalIntermediaryShareholderId),
    shareholdingCompanyName: selectIntermediaryShareholdingCompanyName(
      state,
      externalIntermediaryShareholderId
    ),
  }
}

const mapDispatchToProps = {
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirect: aPush,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withSuspense(false)(ExistingIntermediaryShareHolders)
)
